import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { Spacer } from '@components/spacer/models';

@Component({
  selector: 'app-spacer',
  imports: [],
  templateUrl: './spacer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpacerComponent extends AbstractDynamicComponent<Spacer> {}
